import React from "react";
import { Box, Typography, Card, CardContent, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StatusWiseSummaryComponent from "./StatusWiseSummary";

const ProgressBar = ({ value, total, color }) => (
  <Box
    sx={{
      width: "100%",
      bgcolor: "#cfd8dc",
      borderRadius: 5,
      height: 10,
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        width: `${total > 0 ? (value / total) * 100 : 0}%`,
        bgcolor: color,
        height: "100%",
        borderRadius: 5,
      }}
    />
  </Box>
);

const PerformanceCard = ({
  title,
  total,
  openCount,
  closedCount,
  openLabel,
  closedLabel,
  onOpenClick,
  onClosedClick,
}) => (
  <Card
    sx={{
      textAlign: "center",
      borderLeft: "4px solid rgba(75, 192, 192, 1)",
      minHeight: 300,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    }}
  >
    <CardContent sx={{ flexGrow: 1 }}>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>
      <Typography variant="h4" fontWeight="bold" color="secondary" gutterBottom>
        {total}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Box display="flex" flexDirection="column" mb={2}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography
              sx={{
                fontSize: "1rem",
                flex: 1,
                cursor: "pointer",
                textDecoration: "underline",
              }}
              color="primary"
              onClick={onOpenClick}
            >
              {openLabel}
            </Typography>
            <Typography
              sx={{ fontSize: "1rem", fontWeight: "bold", color: "secondary" }}
            >
              {openCount} / {total}
            </Typography>
          </Box>
          <ProgressBar
            value={openCount}
            total={total}
            color="#4caf50" // Use theme color if possible
          />
        </Box>

        <Box display="flex" flexDirection="column" mb={2}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography
              sx={{
                fontSize: "1rem",
                flex: 1,
                cursor: "pointer",
                textDecoration: "underline",
              }}
              color="primary"
              onClick={onClosedClick}
            >
              {closedLabel}
            </Typography>
            <Typography
              sx={{ fontSize: "1rem", fontWeight: "bold", color: "secondary" }}
            >
              {closedCount} / {total}
            </Typography>
          </Box>
          <ProgressBar
            value={closedCount}
            total={total}
            color="#f44336" // Use theme color if possible
          />
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const AgentOverallPerformanceComponent = ({ data, filters }) => {
  const navigate = useNavigate();

  const navigateToReport = (path, tab) => {
    navigate(path, { state: { activeTab: tab, prevFilters: filters } });
  };

  const agentCounts = data?.agent_wise_summary?.[0]?.counts || {};
  const followups = agentCounts.followups || {};

  return (
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <PerformanceCard
            title="Total Remarks Done"
            total={agentCounts.total_remarks ?? 0}
            openCount={agentCounts.open_remarks ?? 0}
            closedCount={agentCounts.closed_remarks ?? 0}
            openLabel="Open"
            closedLabel="Closed"
            onOpenClick={() => navigateToReport("/remark_details_report", 0)}
            onClosedClick={() => navigateToReport("/remark_details_report", 1)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PerformanceCard
            title="Total Follow-up"
            total={followups.total ?? 0}
            openCount={followups.completed ?? 0}
            closedCount={followups.pending ?? 0}
            openLabel="Completed"
            closedLabel="Pending"
            onOpenClick={() => navigateToReport("/followup_details_report", 0)}
            onClosedClick={() =>
              navigateToReport("/followup_details_report", 1)
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <StatusWiseSummaryComponent data={data} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AgentOverallPerformanceComponent;
